import React, { useState } from "react"

const SlideHeightContext = React.createContext(null)
const defaultSettings = 0

export const SlideHeightProvider = ({ children, settings }) => {
  const [currentSlideHeight, setSlideHeight] = useState(
    settings || defaultSettings
  )

  const updateSlideHeight = values => {
    setSlideHeight(values)
  }

  return (
    <SlideHeightContext.Provider
      value={{ slideHeight: currentSlideHeight, updateSlideHeight }}
    >
      {children}
    </SlideHeightContext.Provider>
  )
}

export const SlideHeightConsumer = SlideHeightContext.Consumer

export default SlideHeightContext

export const useSlideHeight = () => {
  return React.useContext(SlideHeightContext)
}
